module.exports = __webpack_public_path__ + "static/img/22.1.1a564594.png";